var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:order:page:list"],
              expression: "['platform:order:page:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    inline: "",
                    "label-position": "right",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：", "label-width": "66px" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单编号",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "orderNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleSearchList },
                          model: {
                            value: _vm.tableFrom.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "type", $$v)
                            },
                            expression: "tableFrom.type",
                          },
                        },
                        _vm._l(_vm.fromType, function (item, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: item.text, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户搜索：", "label-for": "nickname" } },
                    [
                      _c("UserSearchInput", {
                        model: {
                          value: _vm.tableFrom,
                          callback: function ($$v) {
                            _vm.tableFrom = $$v
                          },
                          expression: "tableFrom",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户名称：" } },
                    [
                      _c("merchant-name", {
                        attrs: { merIdChecked: _vm.tableFrom.merId },
                        on: { getMerId: _vm.getMerId },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "账号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入账号",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.account,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "account",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.account",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品名称",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.productName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "productName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.productName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearchList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              on: { "tab-click": _vm.handleSearchList },
              model: {
                value: _vm.tableFrom.status,
                callback: function ($$v) {
                  _vm.$set(_vm.tableFrom, "status", $$v)
                },
                expression: "tableFrom.status",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  name: "all",
                  label: "全部(" + (_vm.orderChartType.all || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "unPaid",
                  label: "未支付(" + (_vm.orderChartType.unPaid || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "notShipped",
                  label: "未发货(" + (_vm.orderChartType.notShipped || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "spike",
                  label: "待收货(" + (_vm.orderChartType.spike || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "awaitVerification",
                  label:
                    "待核销(" + (_vm.orderChartType.verification || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "receiving",
                  label: "已收货(" + (_vm.orderChartType.receiving || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "complete",
                  label: "已完成(" + (_vm.orderChartType.complete || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "refunded",
                  label: "已退款(" + (_vm.orderChartType.refunded || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "cancel",
                  label: "已取消(" + (_vm.orderChartType.cancel || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "deleted",
                  label: "已删除(" + (_vm.orderChartType.deleted || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "virtualFailed",
                  label:
                    "订购失败(" + (_vm.orderChartType.virtualFailed || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "virtualOrdering",
                  label:
                    "订购中(" + (_vm.orderChartType.virtualOrdering || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "virtualUnsubscribe",
                  label:
                    "退订(" +
                    (_vm.orderChartType.virtualUnsubscribe || 0) +
                    ")",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt5" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["platform:export:order:excel"],
                      expression: "['platform:export:order:excel']",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.exports },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
                "row-key": function (row) {
                  return row.orderNo
                },
              },
            },
            [
              _vm.checkedCities.includes("订单编号")
                ? _c("el-table-column", {
                    attrs: { label: "订单编号", "min-width": "220" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _c(
                                    "font",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.type === 1,
                                          expression: "scope.row.type === 1",
                                        },
                                      ],
                                      staticClass: "mr5",
                                    },
                                    [_vm._v("[秒杀]")]
                                  ),
                                  _c(
                                    "font",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.type === 2,
                                          expression: "scope.row.type === 2",
                                        },
                                      ],
                                      staticClass: "mr5",
                                    },
                                    [_vm._v("[拼团]")]
                                  ),
                                  _c("span", {
                                    staticStyle: { display: "block" },
                                    domProps: {
                                      textContent: _vm._s(scope.row.orderNo),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          parseInt(scope.row.refundStatus) > 0,
                                        expression:
                                          "parseInt(scope.row.refundStatus) > 0",
                                      },
                                    ],
                                    staticClass: "colorPrompt",
                                    staticStyle: { display: "block" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("orderRefundStatusFilter")(
                                          scope.row.refundStatus
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.refundStatus == 2,
                                        expression: "scope.row.refundStatus==2",
                                      },
                                    ],
                                    staticClass: "colorPrompt",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "（已退款 " +
                                          scope.row.refundNum +
                                          " / 购买 " +
                                          scope.row.totalNum +
                                          "）"
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.isUserDel,
                                      expression: "scope.row.isUserDel",
                                    },
                                  ],
                                  staticClass: "colorPrompt",
                                  staticStyle: { display: "block" },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3003671870
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "productName",
                      label: "商品名称",
                      "min-width": "200",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商户名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "merName",
                      label: "商户名称",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("下游订单号")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "outOrderNo",
                      label: "下游订单号",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("供应商名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "channelName",
                      label: "供应商名称",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("账号")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "account",
                      label: "账号",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("实际支付")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "payPrice",
                      label: "实际支付",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("订单状态")
                ? _c("el-table-column", {
                    attrs: { label: "订单状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.refundStatus === 3
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "textE93323 tag-background notStartTag tag-padding",
                                    },
                                    [_vm._v("已退款")]
                                  )
                                : scope.row.groupBuyRecordStatus == 99 ||
                                  scope.row.status == 9 ||
                                  scope.row.groupBuyRecordStatus == 10
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "tag-background tag-padding",
                                      class:
                                        scope.row.status < 5
                                          ? "doingTag"
                                          : "endTag",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("orderStatusFilter")(
                                            scope.row.status
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "textE93323 tag-background notStartTag tag-padding",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.groupBuyRecordStatus == 0
                                            ? "拼团中"
                                            : "拼团失败"
                                        )
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3118831633
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("下单时间")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "140",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("链路日志")
                ? _c("el-table-column", {
                    attrs: { label: "链路日志", "min-width": "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    placement: "top",
                                    effect: "light",
                                    content: _vm.formatJSON(scope.row.logs),
                                    enterable: "",
                                    "popper-class": "log-tooltip",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "log-content" }, [
                                    _vm._v(_vm._s(scope.row.logs)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3926319792
                    ),
                  })
                : _vm._e(),
              _vm.checkPermi(["platform:order:info"])
                ? _c(
                    "el-table-column",
                    {
                      attrs: { width: "120", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.groupBuyRecordStatus != 0
                                  ? _c(
                                      "div",
                                      { staticClass: "operation-buttons" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.onOrderDetails(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("详情")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "8px",
                                            },
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                scope.row.callBackLoading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleOrderCallBack(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 重新下发 ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        58574798
                      ),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("p", [
                          _c(
                            "span",
                            { staticStyle: { "padding-right": "5px" } },
                            [_vm._v("操作")]
                          ),
                          _c("i", {
                            staticClass: "el-icon-setting",
                            on: { click: _vm.handleAddItem },
                          }),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { orderNo: _vm.orderNo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }